// @ts-nocheck
/**
 * bundle-waterproof.js
 * Loaded exclusively on /collections/waterproof-bundle.
 *
 * Flow:
 *   1. Customer clicks ADD on a product card.
 *   2a. Single-variant product → item added directly to the in-memory bundle.
 *   2b. Multi-variant product  → variant picker overlay opens.
 *   3. Customer selects options → clicks "ADD TO BOX" → item added.
 *   4. Bottom bar shows thumbnails + count; checkout button unlocks at 7.
 *   5. On checkout: cart is cleared, all 7 variants are posted to /cart/add.js,
 *      then the browser is redirected to /checkout.
 */

(function () {
  'use strict';

  const BUNDLE_SIZE = 7;
  const BUNDLE_PAID_VARIANT_ID = 56988498133152;

  // ── In-memory state ─────────────────────────────────────────────────────────

  const items = [];

  // ── Cached DOM refs (set in init) ───────────────────────────────────────────

  const refs = {
    grid:        null,
    bar:         null,
    count:       null,
    slots:       null,
    checkoutBtn: null,
    overlay:     null,
    panel:       null,
    content:     null,
    backdrop:    null,
    closeBtn:    null,
    qvModal:     null,
    qvBackdrop:  null,
    qvPanel:     null,
    qvBody:      null,
    qvClose:     null,
  };

  let activeCard   = null;
  let uidCounter   = 0;
  let qvCard       = null;
  let qvImgIdx     = 0;

  // ── Initialisation ──────────────────────────────────────────────────────────

  function init() {
    refs.grid        = document.getElementById('bundle-grid');
    refs.bar         = document.getElementById('bundle-bar');
    refs.count       = document.getElementById('bundle-bar-count');
    refs.slots       = document.getElementById('bundle-bar-slots');
    refs.checkoutBtn = /** @type {HTMLButtonElement} */ (document.getElementById('bundle-checkout-btn'));
    refs.overlay     = document.getElementById('bundle-overlay');
    refs.panel       = document.getElementById('bundle-overlay-panel');
    refs.content     = document.getElementById('bundle-overlay-content');
    refs.backdrop    = document.getElementById('bundle-overlay-backdrop');
    refs.closeBtn    = /** @type {HTMLButtonElement} */ (document.getElementById('bundle-overlay-close'));

    // Guard: bail out if any required element is missing.
    if (
      !refs.grid    || !refs.count  || !refs.slots      ||
      !refs.checkoutBtn || !refs.overlay || !refs.panel  ||
      !refs.content || !refs.backdrop    || !refs.closeBtn
    ) return;

    refs.grid.addEventListener('click', onGridClick);
    refs.grid.addEventListener('touchend', onGridTouchEnd, { passive: false });
    refs.slots.addEventListener('click', onSlotsClick);
    refs.checkoutBtn.addEventListener('click', onCheckout);
    refs.backdrop.addEventListener('click', closeOverlay);
    refs.closeBtn.addEventListener('click', closeOverlay);
    refs.content.addEventListener('click', onPickerClick);

    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;
      if (refs.qvModal?.classList.contains('is-open')) closeQuickView();
      else if (refs.overlay?.classList.contains('is-open')) closeOverlay();
    });

    // Close desktop popover when the user scrolls (card drifts away from the panel).
    window.addEventListener('scroll', () => {
      if (refs.overlay?.classList.contains('is-open') && refs.panel?.classList.contains('is-popover')) {
        closeOverlay();
      }
    }, { passive: true });

    // On resize: if overlay is open and the viewport crossed the mobile breakpoint,
    // close it so the next open recalculates the correct mode (popover vs. bottom-sheet).
    window.addEventListener('resize', () => {
      if (refs.overlay?.classList.contains('is-open')) closeOverlay();
    }, { passive: true });

    // Quick View modal (optional — gracefully absent if IDs are missing).
    refs.qvModal    = document.getElementById('bnd-qv');
    refs.qvBackdrop = document.getElementById('bnd-qv-backdrop');
    refs.qvPanel    = document.getElementById('bnd-qv-panel');
    refs.qvBody     = document.getElementById('bnd-qv-body');
    refs.qvClose    = /** @type {HTMLButtonElement} */ (document.getElementById('bnd-qv-close'));
    if (refs.qvModal && refs.qvBackdrop && refs.qvPanel && refs.qvBody && refs.qvClose) {
      refs.qvBackdrop.addEventListener('click', closeQuickView);
      refs.qvClose.addEventListener('click', closeQuickView);
      refs.qvPanel.addEventListener('click', onQVClick);
    }

    initCardGalleries();
    initFilters();
    renderBar();
  }

  // ── Quick-filter by product type ─────────────────────────────────────────────

  function initFilters() {
    const filterBar = document.getElementById('bundle-filters');
    if (!filterBar || !refs.grid) return;

    const types = new Set();
    refs.grid.querySelectorAll('.bundle-card[data-product-type]').forEach((card) => {
      const t = card.dataset.productType;
      if (t) types.add(t);
    });

    [...types].sort().forEach((type) => {
      const btn = document.createElement('button');
      btn.type      = 'button';
      btn.className = 'bundle-filter-btn';
      btn.dataset.filter = type;
      btn.textContent    = type;
      filterBar.appendChild(btn);
    });

    filterBar.addEventListener('click', onFilterClick);
  }

  function onFilterClick(e) {
    const btn = e.target.closest('.bundle-filter-btn');
    if (!btn) return;
    const filter = btn.dataset.filter;

    document.querySelectorAll('.bundle-filter-btn').forEach((b) => b.classList.remove('is-active'));
    btn.classList.add('is-active');

    refs.grid.querySelectorAll('.bundle-card').forEach((card) => {
      const match = filter === 'all' || card.dataset.productType === filter;
      card.style.display = match ? '' : 'none';
    });
  }

  // ── Grid click ──────────────────────────────────────────────────────────────

  function onGridClick(e) {
    // Gallery arrows (prev/next on card images)
    const prevArrow = e.target.closest('[data-action="gallery-prev"]');
    if (prevArrow) { navigateCardGallery(prevArrow.closest('.bundle-card'), -1); return; }
    const nextArrow = e.target.closest('[data-action="gallery-next"]');
    if (nextArrow) { navigateCardGallery(nextArrow.closest('.bundle-card'), 1); return; }

    // Quick View button
    const qvBtn = e.target.closest('[data-action="quick-view"]');
    if (qvBtn) {
      const card = qvBtn.closest('.bundle-card');
      if (card) { const data = readCardData(card); if (data) openQuickView(card, data); }
      return;
    }

    // Click anywhere on the image area (except buttons) → Quick View
    const media = e.target.closest('.bundle-card__media');
    if (media && !e.target.closest('button')) {
      const card = media.closest('.bundle-card');
      if (card) { const data = readCardData(card); if (data) openQuickView(card, data); }
      return;
    }

    // ADD button — existing logic unchanged
    const btn = e.target.closest('[data-action="bundle-add"]');
    if (!btn || btn.disabled) return;
    const card = btn.closest('.bundle-card');
    if (!card) return;
    if (items.length >= BUNDLE_SIZE) return;
    const data = readCardData(card);
    if (!data) return;
    if (data.isSingleVariant) {
      const v = data.variants[0];
      if (v && v.available) addItem(card, v.id, data.image, v.image || null, v.title);
    } else {
      openOverlay(card, data);
    }
  }

  // ── Grid touchend (mobile single-tap fix) ──────────────────────────────────
  // On touch devices the browser first fires touchend, then synthesises a click
  // ~300ms later. If the card has a :hover transform the card shifts on first tap
  // and the synthetic click lands in the wrong place. We handle ADD directly on
  // touchend and call preventDefault() so the synthetic click is never generated.

  function onGridTouchEnd(e) {
    const btn = e.target.closest('[data-action="bundle-add"]');
    if (!btn || btn.disabled) return;
    const card = btn.closest('.bundle-card');
    if (!card || items.length >= BUNDLE_SIZE) return;
    const data = readCardData(card);
    if (!data) return;
    e.preventDefault(); // suppress the follow-up synthetic click to avoid double-fire
    if (data.isSingleVariant) {
      const v = data.variants[0];
      if (v && v.available) addItem(card, v.id, data.image, v.image || null, v.title);
    } else {
      openOverlay(card, data);
    }
  }

  // ── Bundle state mutations ───────────────────────────────────────────────────

  function addItem(card, variantId, productImage, variantImage, variantTitle) {
    if (items.length >= BUNDLE_SIZE) return;

    const data = readCardData(card);
    if (!data) return;

    items.push({
      productId:    data.productId,
      variantId,
      title:        data.title,
      image:        variantImage || productImage,
      displayTitle: (variantTitle && variantTitle !== 'Default Title') ? variantTitle : '',
      uid:          ++uidCounter,
    });

    refs.grid.querySelectorAll('.bundle-card').forEach(syncCardState);
    renderBar();
  }

  function removeItem(index) {
    if (!items[index]) return;
    items.splice(index, 1);
    refs.grid.querySelectorAll('.bundle-card').forEach(syncCardState);
    renderBar();
  }

  // ── Card state sync (called after every add / remove) ────────────────────────

  function syncCardState(card) {
    const productId = card.dataset.productId;
    const count     = items.filter((i) => i.productId === productId).length;
    const isFull    = items.length >= BUNDLE_SIZE;

    card.classList.toggle('is-selected', count > 0);
    card.classList.toggle('is-dimmed',   isFull && count === 0);

    // Re-enable / disable the ADD button based solely on bundle fullness.
    // Only touch available-product buttons (those that have the bag icon).
    const addBtn = card.querySelector('[data-action="bundle-add"]');
    if (addBtn && addBtn.querySelector('.bundle-card__add-icon')) {
      addBtn.disabled = isFull;
    }

    // Count badge — visible only when the same product is added more than once.
    let badge = card.querySelector('.bundle-card__count-badge');
    if (count > 1) {
      if (!badge) {
        badge = document.createElement('div');
        badge.className = 'bundle-card__count-badge';
        card.querySelector('.bundle-card__media')?.appendChild(badge);
      }
      badge.textContent = `×${count}`;
    } else if (badge) {
      badge.remove();
    }
  }

  // ── Card image gallery ────────────────────────────────────────────────────────

  function initCardGalleries() {
    refs.grid.querySelectorAll('.bundle-card').forEach((card) => {
      const data = readCardData(card);
      if (!data || !data.images || data.images.length < 2) return;

      card._imgIdx = 0;
      const media = card.querySelector('.bundle-card__media');
      if (!media) return;

      const dotsEl = document.createElement('div');
      dotsEl.className = 'bnd-card-dots';
      data.images.forEach((_, i) => {
        const dot = document.createElement('span');
        dot.className = 'bnd-card-dot' + (i === 0 ? ' is-active' : '');
        dotsEl.appendChild(dot);
      });
      media.appendChild(dotsEl);

      const prevEl = document.createElement('button');
      prevEl.type = 'button';
      prevEl.className = 'bnd-card-arrow bnd-card-arrow--prev';
      prevEl.dataset.action = 'gallery-prev';
      prevEl.setAttribute('aria-label', 'Previous image');
      prevEl.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="15 18 9 12 15 6"/></svg>';

      const nextEl = document.createElement('button');
      nextEl.type = 'button';
      nextEl.className = 'bnd-card-arrow bnd-card-arrow--next';
      nextEl.dataset.action = 'gallery-next';
      nextEl.setAttribute('aria-label', 'Next image');
      nextEl.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="9 18 15 12 9 6"/></svg>';

      media.appendChild(prevEl);
      media.appendChild(nextEl);

      // Mobile swipe
      let swipeX = 0;
      media.addEventListener('touchstart', (e) => { swipeX = e.touches[0].clientX; }, { passive: true });
      media.addEventListener('touchend', (e) => {
        const dx = e.changedTouches[0].clientX - swipeX;
        if (Math.abs(dx) > 40) navigateCardGallery(card, dx < 0 ? 1 : -1);
      }, { passive: true });
    });
  }

  function navigateCardGallery(card, dir) {
    if (!card) return;
    const data = readCardData(card);
    if (!data || !data.images || data.images.length < 2) return;

    const total = data.images.length;
    card._imgIdx = (((card._imgIdx || 0) + dir) % total + total) % total;

    const img = card.querySelector('.bundle-card__media > img');
    if (img) img.src = data.images[card._imgIdx];

    card.querySelectorAll('.bnd-card-dot').forEach((dot, i) => {
      dot.classList.toggle('is-active', i === card._imgIdx);
    });
  }

  // ── Quick View modal ──────────────────────────────────────────────────────────

  function openQuickView(card, data) {
    if (!refs.qvModal) return;
    qvCard   = card;
    qvImgIdx = 0;

    refs.qvBody.innerHTML = buildQVHTML(data);

    const gallery = document.getElementById('bnd-qv-gallery');
    if (gallery) {
      let tx = 0;
      gallery.addEventListener('touchstart', (e) => { tx = e.touches[0].clientX; }, { passive: true });
      gallery.addEventListener('touchend', (e) => {
        const dx = e.changedTouches[0].clientX - tx;
        if (Math.abs(dx) > 40) setQVImage(qvImgIdx + (dx < 0 ? 1 : -1));
      }, { passive: true });
    }

    refs.qvModal.classList.add('is-open');
    refs.qvModal.removeAttribute('aria-hidden');
    document.body.classList.add('bnd-qv-open');
    setTimeout(() => refs.qvClose?.focus(), 60);
  }

  function closeQuickView() {
    if (!refs.qvModal) return;
    refs.qvModal.classList.remove('is-open');
    refs.qvModal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('bnd-qv-open');
    qvCard = null;
  }

  function buildQVHTML(data) {
    const imgs       = (data.images && data.images.length) ? data.images : (data.image ? [data.image] : []);
    const isFull     = items.length >= BUNDLE_SIZE;
    const singleV    = data.isSingleVariant && data.variants && data.variants[0];
    const singleOK   = !!singleV && singleV.available && !isFull;

    let html = '';

    // Gallery
    html += '<div class="bnd-qv__gallery" id="bnd-qv-gallery"><div class="bnd-qv__imgs">';
    imgs.forEach((src, i) => {
      html += `<img class="bnd-qv__img${i === 0 ? ' is-active' : ''}" src="${esc(src)}" alt="${esc(data.title)}" loading="${i === 0 ? 'eager' : 'lazy'}">`;
    });
    html += '</div>';
    if (imgs.length > 1) {
      html += '<button class="bnd-qv__arrow bnd-qv__arrow--prev" id="bnd-qv-prev" type="button" aria-label="Previous image">' +
              '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="15 18 9 12 15 6"/></svg></button>';
      html += '<button class="bnd-qv__arrow bnd-qv__arrow--next" id="bnd-qv-next" type="button" aria-label="Next image">' +
              '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="9 18 15 12 9 6"/></svg></button>';
      html += '<div class="bnd-qv__dots">';
      imgs.forEach((_, i) => {
        html += `<span class="bnd-qv__dot${i === 0 ? ' is-active' : ''}" data-qv-dot="${i}"></span>`;
      });
      html += '</div>';
    }
    html += '</div>'; // end gallery

    // Content
    html += '<div class="bnd-qv__content">';
    if (data.productType) html += `<p class="bnd-qv__type">${esc(data.productType)}</p>`;
    html += `<h2 class="bnd-qv__title">${esc(data.title)}</h2>`;

    if (!data.isSingleVariant && data.options && data.options.length) {
      data.options.forEach((opt, i) => {
        html += `<div class="bnd-qv__option" data-pos="${i}">`;
        html += `<p class="bnd-qv__opt-label">${esc(opt.name)}</p>`;
        html += '<div class="bnd-qv__opt-values">';
        opt.values.forEach((val) => {
          const hasStock = data.variants.some((v) => v[`option${i + 1}`] === val && v.available);
          html += `<button class="bnd-qv__opt-val${hasStock ? '' : ' is-unavailable'}" data-opt-index="${i}" data-val="${esc(val)}" type="button"${hasStock ? '' : ' disabled'}>${esc(val)}</button>`;
        });
        html += '</div></div>';
      });
    }

    const addAttrs = singleV
      ? ` data-variant-id="${singleV.id}" data-variant-image="${esc(singleV.image || '')}" data-variant-title="${esc(singleV.title || '')}"`
      : '';
    html += `<button class="bnd-qv__add-btn" id="bnd-qv-add" type="button"${singleOK ? '' : ' disabled'}${addAttrs}>`;
    html += isFull ? 'Bundle is full' : 'ADD TO CART';
    html += '</button>';

    if (data.descriptionHtml) {
      html += `<div class="bnd-qv__desc">${data.descriptionHtml}</div>`;
    }
    html += '</div>'; // end content
    return html;
  }

  function setQVImage(idx) {
    if (!refs.qvBody) return;
    const imgs = refs.qvBody.querySelectorAll('.bnd-qv__img');
    if (!imgs.length) return;
    const total = imgs.length;
    qvImgIdx = ((idx % total) + total) % total;
    imgs.forEach((img, i) => img.classList.toggle('is-active', i === qvImgIdx));
    refs.qvBody.querySelectorAll('.bnd-qv__dot').forEach((dot, i) => {
      dot.classList.toggle('is-active', i === qvImgIdx);
    });
  }

  function resolveQVVariant() {
    if (!qvCard || !refs.qvBody) return;
    const data = readCardData(qvCard);
    if (!data || data.isSingleVariant) return;

    const selections = data.options.map((_, i) => {
      const sel = refs.qvBody.querySelector(`.bnd-qv__option[data-pos="${i}"] .bnd-qv__opt-val.is-selected`);
      return sel ? sel.dataset.val : null;
    });

    const addBtn = document.getElementById('bnd-qv-add');
    if (!addBtn) return;

    if (selections.some((s) => s === null) || items.length >= BUNDLE_SIZE) {
      addBtn.disabled = true;
      return;
    }

    const match = data.variants.find((v) =>
      selections.every((sel, i) => v[`option${i + 1}`] === sel)
    );

    if (match && match.available) {
      addBtn.disabled             = false;
      addBtn.dataset.variantId    = String(match.id);
      addBtn.dataset.variantImage = match.image || '';
      addBtn.dataset.variantTitle = match.title || '';
    } else {
      addBtn.disabled = true;
      delete addBtn.dataset.variantId;
    }
  }

  function onQVClick(e) {
    if (e.target.closest('#bnd-qv-prev')) { setQVImage(qvImgIdx - 1); return; }
    if (e.target.closest('#bnd-qv-next')) { setQVImage(qvImgIdx + 1); return; }

    const dot = e.target.closest('[data-qv-dot]');
    if (dot) { setQVImage(parseInt(dot.dataset.qvDot, 10)); return; }

    const optBtn = e.target.closest('.bnd-qv__opt-val:not([disabled])');
    if (optBtn) {
      const pos   = parseInt(optBtn.dataset.optIndex, 10);
      const group = refs.qvBody.querySelector(`.bnd-qv__option[data-pos="${pos}"] .bnd-qv__opt-values`);
      group?.querySelectorAll('.bnd-qv__opt-val').forEach((b) => b.classList.remove('is-selected'));
      optBtn.classList.add('is-selected');
      resolveQVVariant();
      return;
    }

    const addBtn = e.target.closest('#bnd-qv-add');
    if (addBtn && !addBtn.disabled) {
      if (!qvCard || items.length >= BUNDLE_SIZE) return;
      const variantId    = parseInt(addBtn.dataset.variantId, 10);
      const variantImage = addBtn.dataset.variantImage || null;
      const variantTitle = addBtn.dataset.variantTitle || '';
      const cardData     = readCardData(qvCard);
      addItem(qvCard, variantId, cardData ? cardData.image : null, variantImage, variantTitle);
      closeQuickView();
    }
  }

  // ── Bottom bar rendering ─────────────────────────────────────────────────────

  function renderBar() {
    refs.count.textContent = String(items.length);

    if (refs.bar) {
      refs.bar.classList.toggle('is-visible', items.length > 0);
    }

    const slots = refs.slots.querySelectorAll('.bundle-bar__slot');

    slots.forEach((slot, i) => {
      const item = items[i];
      if (item) {
        slot.className = 'bundle-bar__slot is-filled';
        slot.innerHTML = item.image
          ? `<img src="${esc(item.image)}" alt="${esc(item.title)}" loading="lazy">
             <button class="bundle-bar__remove" data-remove-index="${i}" type="button" aria-label="Remove ${esc(item.title)}">
               <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18M6 6l12 12"/></svg>
             </button>`
          : `<button class="bundle-bar__remove" data-remove-index="${i}" type="button" aria-label="Remove ${esc(item.title)}">
               <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18M6 6l12 12"/></svg>
             </button>`;
      } else {
        slot.className = 'bundle-bar__slot is-empty';
        slot.innerHTML = `<span class="bundle-bar__slot-num">${i + 1}</span>`;
      }
    });

    const complete = items.length === BUNDLE_SIZE;
    refs.checkoutBtn.disabled = !complete;
    refs.checkoutBtn.setAttribute('aria-disabled', String(!complete));
    refs.checkoutBtn.classList.toggle('is-active', complete);
    refs.checkoutBtn.setAttribute(
      'aria-label',
      complete ? 'Proceed to checkout' : 'Proceed to checkout — select 7 items first'
    );
  }

  function onSlotsClick(e) {
    const btn = e.target.closest('[data-remove-index]');
    if (!btn) return;
    removeItem(parseInt(btn.dataset.removeIndex, 10));
  }

  // ── Variant overlay ──────────────────────────────────────────────────────────

  function openOverlay(card, data) {
    activeCard = card;
    refs.content.innerHTML = buildPickerHTML(data);

    const isMobile = window.innerWidth < 750;
    refs.panel.classList.toggle('is-popover', !isMobile);
    refs.panel.classList.toggle('is-bottom-sheet', isMobile);

    if (!isMobile) {
      positionPopover(card);
    } else {
      // Bottom sheet: CSS handles the position.
      refs.panel.style.top  = '';
      refs.panel.style.left = '';
    }

    refs.overlay.classList.add('is-open');
    refs.overlay.removeAttribute('aria-hidden');
    document.body.classList.add('bundle-overlay-open');

    // Move focus into the panel for keyboard users.
    setTimeout(() => refs.closeBtn.focus(), 60);
  }

  function closeOverlay() {
    refs.overlay.classList.remove('is-open');
    refs.overlay.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('bundle-overlay-open');
    activeCard = null;
  }

  /**
   * Position the popover to the right (or left) of the product card.
   * Uses fixed coordinates since the panel is position:fixed.
   */
  function positionPopover(card) {
    const rect     = card.getBoundingClientRect();
    const panelW   = 300;
    const margin   = 14;
    const vpW      = window.innerWidth;
    const vpH      = window.innerHeight;

    let left = rect.right + margin;
    if (left + panelW > vpW - margin) left = rect.left - panelW - margin;
    if (left < margin) left = margin;

    // Estimate panel height; clamp so it stays in view.
    const estimatedH = 420;
    let top = rect.top;
    if (top + estimatedH > vpH - margin) top = vpH - estimatedH - margin;
    if (top < margin) top = margin;

    refs.panel.style.top  = `${top}px`;
    refs.panel.style.left = `${left}px`;
  }

  // ── Variant picker HTML builder ──────────────────────────────────────────────

  function buildPickerHTML(data) {
    const { productId, title, image, variants, options } = data;

    let html = `<div class="bundle-picker" data-product-id="${productId}">`;

    html += `<div class="bundle-picker__head">`;
    if (image) html += `<img class="bundle-picker__img" src="${esc(image)}" alt="${esc(title)}" loading="lazy">`;
    html += `<p class="bundle-picker__product-title">${esc(title)}</p>`;
    html += `</div>`;

    options.forEach((opt, i) => {
      html += `<div class="bundle-picker__option" data-pos="${i}">`;
      html += `<p class="bundle-picker__opt-label">${esc(opt.name)}</p>`;
      html += `<div class="bundle-picker__opt-values">`;

      opt.values.forEach((val) => {
        // A value is available if at least one variant with that option value is in stock.
        const hasStock = variants.some(
          (v) => v[`option${i + 1}`] === val && v.available
        );

        html += `<button
          class="bundle-picker__opt-val${hasStock ? '' : ' is-unavailable'}"
          data-opt-index="${i}"
          data-val="${esc(val)}"
          type="button"
          ${hasStock ? '' : 'disabled'}
        >${esc(val)}</button>`;
      });

      html += `</div></div>`;
    });

    html += `<button class="bundle-picker__add-btn" id="bundle-picker-add" type="button" disabled>
        ADD TO CART
    </button>`;

    html += `</div>`;
    return html;
  }

  // ── Picker click handler (option selection + "add to box") ──────────────────

  function onPickerClick(e) {
    const optBtn = /** @type {HTMLButtonElement|null} */ (
      e.target.closest('.bundle-picker__opt-val:not([disabled])')
    );
    const addBtn = /** @type {HTMLButtonElement|null} */ (
      e.target.closest('#bundle-picker-add')
    );

    if (optBtn) {
      const pos   = parseInt(optBtn.dataset.optIndex, 10);
      const group = refs.content.querySelector(
        `.bundle-picker__option[data-pos="${pos}"] .bundle-picker__opt-values`
      );
      group.querySelectorAll('.bundle-picker__opt-val').forEach((b) =>
        b.classList.remove('is-selected')
      );
      optBtn.classList.add('is-selected');
      resolveVariant();
    }

    if (addBtn && !addBtn.disabled) {
      if (!activeCard) return;

      const variantId    = parseInt(addBtn.dataset.variantId, 10);
      const variantImage = addBtn.dataset.variantImage || null;
      const variantTitle = addBtn.dataset.variantTitle || '';
      const data         = readCardData(activeCard);

      addItem(activeCard, variantId, data ? data.image : null, variantImage, variantTitle);
      closeOverlay();
    }
  }

  /**
   * Check whether all options are selected and, if so, find the matching variant.
   * Enables/disables the "ADD TO BOX" button accordingly.
   */
  function resolveVariant() {
    if (!activeCard) return;

    const data = readCardData(activeCard);
    if (!data) return;

    const { variants, options } = data;

    // Collect the currently selected value for each option dimension.
    const selections = options.map((_, i) => {
      const sel = refs.content.querySelector(
        `.bundle-picker__option[data-pos="${i}"] .bundle-picker__opt-val.is-selected`
      );
      return sel ? sel.dataset.val : null;
    });

    const pickerAddBtn = /** @type {HTMLButtonElement|null} */ (
      document.getElementById('bundle-picker-add')
    );
    if (!pickerAddBtn) return;

    // All dimensions must be chosen before we can resolve a variant.
    if (selections.some((s) => s === null)) {
      pickerAddBtn.disabled = true;
      return;
    }

    const match = variants.find((v) =>
      selections.every((sel, i) => v[`option${i + 1}`] === sel)
    );

    if (match && match.available) {
      pickerAddBtn.disabled               = false;
      pickerAddBtn.dataset.variantId      = String(match.id);
      pickerAddBtn.dataset.variantImage   = match.image || '';
      pickerAddBtn.dataset.variantTitle   = match.title || '';
    } else {
      pickerAddBtn.disabled = true;
      delete pickerAddBtn.dataset.variantId;
    }
  }

  // ── Checkout ─────────────────────────────────────────────────────────────────

  async function onCheckout() {
    if (items.length < BUNDLE_SIZE) return;

    const btn = refs.checkoutBtn;
    btn.disabled    = true;
    btn.textContent = 'Adding…';
    btn.classList.add('is-loading');

    try {
      // 1. Clear the existing cart so only bundle items land in checkout.
      const clearRes = await fetch('/cart/clear.js', { method: 'POST' });
      if (!clearRes.ok) throw new Error(`clear error ${clearRes.status}`);

      // 2. Add all 7 bundle items + 1 paid product in a single request.
      // Each free item gets a hidden _bundle_item property so the cart can
      // detect and group them under the paid bundle card (Louise Carter style).
      const bundleItemTitles = items.map((item) => {
        const label = [item.title, item.displayTitle].filter(Boolean).join(' - ');
        return label;
      });

      const addRes = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [
            ...items.map((item) => ({
              id: item.variantId,
              quantity: 1,
              properties: { '_bundle_item': 'true' },
            })),
            {
              id: BUNDLE_PAID_VARIANT_ID,
              quantity: 1,
              properties: { '_bundle_items_summary': bundleItemTitles.join('||') },
            },
          ],
        }),
      });

      if (!addRes.ok) {
        const err = await addRes.json().catch(() => ({}));
        throw new Error(err.description || `cart/add error ${addRes.status}`);
      }

      // 3. Redirect to Shopify's native checkout.
      window.location.href = '/checkout';
    } catch (err) {
      console.error('[bundle-waterproof] checkout error:', err);

      btn.classList.remove('is-loading');
      btn.classList.add('is-active');
      btn.disabled    = false;
      btn.textContent = 'Error — try again';

      setTimeout(() => {
        btn.textContent = 'CHECKOUT';
      }, 3500);
    }
  }

  // ── Helpers ──────────────────────────────────────────────────────────────────

  /**
   * Read the JSON data embedded inside a bundle card's <script> tag.
   */
  function readCardData(card) {
    const script = card.querySelector('.bundle-card__json');
    if (!script) return null;
    try {
      return JSON.parse(script.textContent);
    } catch (e) {
      console.error('[bundle-waterproof] failed to parse card JSON:', e);
      return null;
    }
  }

  /**
   * Escape a value for safe use inside HTML attributes and text content.
   */
  function esc(str) {
    if (str == null) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  // ── Boot ─────────────────────────────────────────────────────────────────────

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
